module.exports = __webpack_public_path__ + "img/template-icon-active.2f3e7b48.svg";